import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../context/context";
import moment from "moment";
import DateRangePicker from "@wojtekmaj/react-daterange-picker/dist/DateRangePicker";
import { getZones } from "../../../services/zone-service";

import "./VolumeZona.scss";
import {
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import LineChart from "../../../components/LineChart/LineChart";
import { getVolumeByZone } from "../../../services/graphics-service";
import { formatGraphicVolumePerZones } from "../../../utils/formatted-graphic-values";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
};

const VolumeZona = () => {
  const { sidebar } = useContext(Context);
  const token = localStorage.getItem("token");
  const [zones, setZones] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [graphicValues, setGraphicValues] = useState({});
  const [showGraphic, setShowGraphic] = useState(false);
  const [dateValue, setDateValue] = useState([
    moment(new Date()).subtract(30, "day").toDate(),
    new Date(),
  ]);

  const getZonesList = async () => {
    const zones = await getZones(token);
    setZones(zones);
  };

  useEffect(() => {
    getZonesList();
  }, []);

  const getGraphicData = async () => {
    const result = await getVolumeByZone(
      token,
      selectedZones,
      dateValue[0],
      dateValue[1]
    );

    setGraphicValues(formatGraphicVolumePerZones(result.data.zonesVolume));

    setShowGraphic(true);
  };

  return (
    <main className={sidebar ? "container" : "container-full"}>
      <h1>Volume perdido por zona</h1>

      <div className="graphic-csv-container">
        <p>Favor escolher as zonas para gerar o gráfico</p>

        <DateRangePicker onChange={(e) => setDateValue(e)} value={dateValue} />
        <div>
          <FormControl style={{ width: "272px" }}>
            <InputLabel id="demo-multiple-checkboxx-label">Zonas</InputLabel>
            <Select
              labelId="demo-multiple-checkboxx-label"
              id="demo-multiple-checkbox"
              multiple
              value={selectedZones}
              onChange={(e) => setSelectedZones(e.target.value)}
              input={<OutlinedInput label="Zonas" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              {zones.map((item) => (
                <MenuItem key={item.name} value={item.id}>
                  <Checkbox checked={selectedZones.indexOf(item.id) > -1} />
                  <ListItemText primary={item.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <Button
          className="generate-btn"
          variant="contained"
          onClick={getGraphicData}
        >
          Gerar gráfico
        </Button>
      </div>

      {showGraphic && (
        <div className="graphic-container">
          <LineChart values={graphicValues} />
        </div>
      )}
    </main>
  );
};

export default VolumeZona;
